

export class Employee_Dashboard_Monthly_Missing_Thumb implements IEmployee_Dashboard_Monthly_Missing_Thumb {
    employeeId!: number | undefined;
    eventDate!: Date | undefined;
    inDateTime!: Date | undefined;
    outDateTime!: Date | undefined;

    constructor(data?: IEmployee_Dashboard_Monthly_Missing_Thumb) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.inDateTime = _data["inDateTime"] ? new Date(_data["inDateTime"].toString()) : <any>undefined;
            this.outDateTime = _data["outDateTime"] ? new Date(_data["outDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Employee_Dashboard_Monthly_Missing_Thumb {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_Monthly_Missing_Thumb();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["inDateTime"] = this.inDateTime ? this.inDateTime.toISOString() : <any>undefined;
        data["outDateTime"] = this.outDateTime ? this.outDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEmployee_Dashboard_Monthly_Missing_Thumb {
    employeeId: number | undefined;
    eventDate: Date | undefined;
    inDateTime: Date | undefined;
    outDateTime: Date | undefined;
}

